import $ from 'jquery';
import 'bootstrap';

/** @enum */
export const Events = {
	Closed: 'closed',
}

const Toast = {
	name: 'Toast',
	props: {
		heading: String,
		text: String,
		bgcolor: String,
		textcolor: String,
		autohide: {
			type: Boolean,
			default: false,
		},
		delay: {
			type: Number,
			default: 500,
		},
	},
	mounted() {
		$(this.$el)
			.toast({
				autohide: this.autohide,
				delay: this.delay,
			})
			.on('hidden.bs.toast', () => {
				this.$emit(Events.Closed)
			})
			.toast('show')
	},
	beforeDestroy() {
		$(this.$el).toast('dispose')
	},
	render() {
		return (
			<div class="toast hide" role="alert" aria-live="assertive" aria-atomic="true">
				<div class="toast-header" style={{
					backgroundColor: this.bgcolor,
				}}>
					<strong class="mr-auto" style={{
						color: this.textcolor,
					}}>
						{ this.heading }
					</strong>
					<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="toast-body">
					{ this.text }
				</div>
			</div>
		)
	}
}

export default Toast
